import { render, staticRenderFns } from "./BaseInfoPanelWithBadge.vue?vue&type=template&id=0a76b21a&scoped=true"
import script from "./BaseInfoPanelWithBadge.vue?vue&type=script&lang=ts"
export * from "./BaseInfoPanelWithBadge.vue?vue&type=script&lang=ts"
import style0 from "./BaseInfoPanelWithBadge.vue?vue&type=style&index=0&id=0a76b21a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a76b21a",
  null
  
)

export default component.exports